import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const HowWeWork: React.FC = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const workSteps = [
    {
      title: "Pesquisa",
      description: "Imergimos no contexto do projeto para compreensão das reais necessidades do cliente.",
      image: "/images/index-presentation-1.jpg"
    },
    {
      title: "Estudos",
      description: "Analisamos as soluções mais adequadas para diferentes contextos e personas.",
      image: "/images/index-presentation-3.jpg"
    },
    {
      title: "Interfaces",
      description: "Desenhamos produtos multitelas funcionais e focados no usuário.",
      image: "/images/startup-photos_filter.jpg"
    },
    {
      title: "Desenvolvimento",
      description: "Construímos sistemas sob-medida, plataformas e soluções digitais para atender demandas diversas.",
      image: "/images/index-presentation-2.jpg"
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="section-padding bg-gray-50">
      <div ref={ref} className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-secondary-900 mb-6">
            Como trabalhamos
          </h2>
          <p className="text-lg text-secondary-600 max-w-4xl mx-auto leading-relaxed">
            Criamos experiências digitais a partir de uma visão holística do projeto, sem perder o foco do usuário final. 
            Unimos o raciocínio analítico, conhecimento tecnológico e empatia para criar produtos eficientes e que atendam 
            as reais necessidades dos nossos clientes.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {workSteps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-lg shadow-lg overflow-hidden card-hover"
            >
              <div className="aspect-w-16 aspect-h-9">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-48 object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold font-heading text-secondary-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-secondary-600 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="text-center"
        >
          <button
            onClick={scrollToContact}
            className="btn-secondary hover:bg-primary-600 hover:text-white text-lg px-8 py-4"
          >
            O que precisa?
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default HowWeWork;
